import { useCartContextProvider } from "../../hooks";
import { Divider } from "@towersystems/roam-common-native";
import { CartItem } from "../CartItem";
import { Spacings } from "react-native-ui-lib";
import { FlatList } from "react-native";
import KitCartItem from "../CartItem/KitCartItem";

export const Body = () => {
  const { items, navigation } = useCartContextProvider();
  return (
    <FlatList
      nestedScrollEnabled={true}
      style={{
        marginBottom: Spacings.s4,
        paddingBottom: Spacings.s4,
      }}
      scrollEnabled={true}
      ItemSeparatorComponent={Divider}
      data={items}
      renderItem={({ item }) => {
        if (!!item.productKit?.id) {
          return <KitCartItem navigation={navigation} item={item} />;
        } else {
          return <CartItem navigation={navigation} item={item} />;
        }
      }}
    ></FlatList>
  );
};
